export default function getDateForPuzzleNumber(puzzleNumber: number, startDateIso: string) {
	const startDate = new Date(startDateIso)
	const date = new Date(startDate.getTime() + (puzzleNumber - 1) * 24 * 60 * 60 * 1000)
	return date.toISOString().split('T')[0]
}
